import service from '@/store/services/workshop/service_categories-service';

const state = {
  list: {},
  service_categories: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, service_categories) => {
    state.service_categories = service_categories;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((service_categories) => { commit('SET_RESOURCE', service_categories); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((service_categories) => { commit('SET_RESOURCE', service_categories); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((service_categories) => { commit('SET_RESOURCE', service_categories); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  }

  
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  service_categories: state => state.service_categories,
};
 
const service_categories = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default service_categories;
